import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ITemplateSectionState} from '@app/stores';

const selectTemplateSection = createFeatureSelector<ITemplateSectionState>('templateSection');

export const getTemplateSectionError = createSelector(selectTemplateSection, (state: ITemplateSectionState) => state.error);

export const getTemplateSections = createSelector(selectTemplateSection, (state: ITemplateSectionState) => state.templateSections);

export const getTemplateSectionTypes = createSelector(selectTemplateSection, (state: ITemplateSectionState) => state.templateSectionTypes);
